var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import authentication from "@irati/auth";
import { FormattedMessage } from "@irati/utils/lang";
import downloadTenantTransactions from "@irati/wallet/apollo/query/downloadTenantTransactions";
import { H4, H5 } from "@irati/ui/src/Headings";
import { IconTextButton } from "@irati/ui/src/Button";
import ErrorText from "@irati/ui/src/ErrorText";
import id from "@irati/utils/id";
import tracking from "@irati-tracking/wallet/tenantWallet";
import { HeadingWrapper, ButtonWrapper } from "../Transactions/styled";
var TransactionHeader = /** @class */ (function (_super) {
    __extends(TransactionHeader, _super);
    function TransactionHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            error: false
        };
        _this.downloadCsv = function () {
            tracking.downloadReport();
            _this.setState({ loading: true, error: false });
            downloadTenantTransactions()
                .then(function (data) {
                var fileName = authentication.userTenant().subdomain + "-tenant-transaction-report.csv";
                var link = document.createElement("a");
                link.setAttribute("href", "data:text/csv;base64," + btoa(data));
                link.setAttribute("download", fileName);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                _this.setState({ loading: false, error: false });
            })
                .catch(function () {
                _this.setState({ loading: false, error: true });
            });
        };
        return _this;
    }
    TransactionHeader.prototype.render = function () {
        var _a = this.state, loading = _a.loading, error = _a.error;
        var idNamespace = id("TransactionHeader", this.props);
        return (React.createElement(HeadingWrapper, null,
            React.createElement(H4, null,
                React.createElement(FormattedMessage, { id: "wallet.tenant.transactionsHeader" })),
            loading
                ? React.createElement(H5, null,
                    React.createElement(FormattedMessage, { id: "wallet.tenant.loading" }))
                :
                    React.createElement(ButtonWrapper, null,
                        error &&
                            React.createElement(ErrorText, null,
                                React.createElement(FormattedMessage, { id: "wallet.tenant.downloadReport.error" })),
                        React.createElement(IconTextButton, { id: idNamespace, icon: "downloadFile", onClick: this.downloadCsv },
                            React.createElement(H5, null,
                                React.createElement(FormattedMessage, { id: "wallet.tenant.downloadReport.button" }))))));
    };
    return TransactionHeader;
}(PureComponent));
export default TransactionHeader;
